<template>
  <div class="tab">
      <div 
        class="tab_item"
        :class="{ 'tab_item-active': tab.key == selectedTabKey }"
        v-for="tab in tabs"
        :key="tab.key"
        @click="changeTab(tab.key)"
      >
          {{ tab.title }}
      </div>
  </div>
</template>
<script>
export default {
  name: "Tabs",
  props: {
    tabs: {
      type: Array,
      required: true
    }
  },

  data () {
    return {
      selectedTabKey: null
    }
  },

  mounted () {
    if (this.$route.hash == '#indicators') {
      this.changeTab(this.tabs[1].key)
    } else {
      this.changeTab(this.tabs[0].key)
    }
  },

  methods: {
    changeTab (key) {
      this.selectedTabKey = key
      this.$emit('change', this.selectedTabKey)
    }
  }
}
</script>
<style lang="scss" scoped>
  .tab {
    display: flex;

    &_item {
      background-color: #b3edff ;
      padding: 10px 30px;
      border-radius: 10px 10px 0px 0px;
      margin-right: 5px;
      font-weight: 600;
      font-size: 14px;
      border: 2px solid #7edaf5;
      cursor: pointer;

      &-active {
        background-color: #fff;
        border: 1px solid silver;
        border-bottom: 0;
      }
    }
  }
</style>